import { Injectable } from '@angular/core';

// Use the same type as in the component
type TemperatureComponentType = 'generalQuestions';

@Injectable({
  providedIn: 'root'
})
export class TemperatureService {
  private temperatures: Record<TemperatureComponentType, number> = {
    generalQuestions: 0.7,

  };

  getDefaultTemperature(component: TemperatureComponentType): number {
    // Use nullish coalescing so a valid 0 (fully deterministic) isn't treated as falsy.
    return this.temperatures[component] ?? 1.0;
  }

  setTemperature(component: TemperatureComponentType, value: number): void {
    this.temperatures[component] = value;
  }

  resetTemperature(component: TemperatureComponentType): void {
    this.temperatures[component] = 0.7;
  }
}
